module.exports = __webpack_public_path__ + "static/media/Galdisa_Chickpeas snacks.d2a56fc1.pdf";